import {
  citiesAdminControllerList,
  type City,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useQuery } from "@tanstack/react-query";

const getCities = async (): Promise<City[]> => {
  const data = await unwrapApiResponse(
    citiesAdminControllerList<true>({
      query: { limit: 500 },
      throwOnError: true,
    }),
  );
  return Array.isArray(data) ? data : (data as { data: City[] }).data;
};

export const useGetCities = () =>
  useQuery({
    initialData: [],
    queryKey: ["cities"],
    queryFn: getCities,
  });
